import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";
import routeService from "services/RouteService";
import { useMemo } from "react";
import { FundingAppealFormController } from "components/Pages/Funding/FundingAppealFormController";

const EditGoalsModalContent: React.FC<{ clubId: string; appealId: string }> = () => {
  const controller = FundingAppealFormController.use();
  const { saving, loading } = controller.state;
  const fields = useMemo(() => Object.values(controller.fields()), [controller]);

  if (loading) return <LoadingModal title="Fundraising goals" />;

  return (
    <AppModal title="Fundraising goals" className="max-h-[80vh]">
      <Form name="funding_appeal">
        <fieldset disabled={saving}>
          <ModalFormFieldset fields={fields} />
        </fieldset>
        <FormButtons showDelete={false} saveTitle="Save" />
      </Form>
    </AppModal>
  );
};

const EditGoalsView = FundingAppealFormController.scope(ApplicationView(EditGoalsModalContent));

export default injectModal((props: { clubId: string; appealId: string }) => (
  <EditGoalsView
    {...props}
    goalsOnly
    onSubmit={async () => {
      routeService.closeModal();
    }}
  />
));
